import View from "./geographic-info.view";
import Presenter from "./geographic-info.presenter";
import { ConnectComponent } from "util";

export default ConnectComponent(View, Presenter);



// WEBPACK FOOTER //
// ./src/components/app/registration/company/form/geographic-info/index.js